import * as angular from 'angular';
import { downgradeInjectable } from '@angular/upgrade/static';

import { VenueService } from './venue.service';

export const Ng1VenueModule = angular
  .module('control-room.commons.services.venue', [])
  .factory('crVenueService', downgradeInjectable(VenueService));
